import Vue from 'vue';
import VueI18n from 'vue-i18n';
// import numberFormats from '@/locales/numerFormatter';

Vue.use(VueI18n)

import messages from '@/locales/messages';
import numberFormats from '@/locales/numberFormats';

export default new VueI18n({
  locale: 'es',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: messages,
  numberFormats
})